<template>
    <div id="photos" class="photos" ref="photos" :class="{'photos--loading': loadingPhotosByParams}">
        <actionbar v-if="albumPhotos"/>

        <template v-if="!!sets.length && isMobile">
            <div :id="`set-item-${i + 1}`" class="grid-item grid-item--set grid-item--mobile-set" :class="`item-${i}`"
                 v-for="(set, i) in sets" :key="`set-${i}`">
                <div class="grid-item--set-inner">
                    <div class="grid-item--set-title">{{ set.name }}</div>
                    <div class="grid-item--set-description" v-if="set.set.snippet" v-html="set.set.snippet"></div>
                    <ul v-else-if="!!set.products.length" class="grid-item--set-items">
                        <li v-for="(variant, v) in set.products" class="grid-item--set-item" :key="v">
                            {{ variant.quantity }}x {{ variant.product.name }}
                            {{ variant.product.name.search(variant.name) >= 0 ? '' : variant.name }}
                        </li>
                    </ul>
                    <div class="grid-item--set-price">{{ set.price_gross | currency }}</div>
                    <a href="#" @click.prevent="selectSet(set)"
                       class="btn btn-icon-left btn-primary btn-shadow text-uppercase">
                        <span class="material-icon icon-add"></span>
                        {{ $t('select_product') }}
                    </a>
                </div>
            </div>
        </template>

        <isotope v-if="visiblePhotos" ref="isotope" v-images-loaded="layout"
                 :options='isotopeOptions' :list="visiblePhotos" class="grid" v-show="!uuid"><!--:on.progress-->
            <template v-if="!!sets.length && !isMobile">
                <div :id="`photo-${i + 1}`" class="grid-item grid-item--set" :class="`item-${i}`"
                     v-for="(set, i) in sets" :key="`set-${i}`">
                    <div class="grid-item--set-inner">
                        <div class="grid-item--set-title">{{ set.name }}</div>
                        <div class="grid-item--set-description" v-if="set.set.snippet" v-html="set.set.snippet"></div>
                        <ul v-else-if="!!set.products.length" class="grid-item--set-items">
                            <li v-for="(variant, v) in set.products" class="grid-item--set-item" :key="v">
                                {{ variant.quantity }}x {{ variant.product.name }}
                                {{ variant.product.name.search(variant.name) >= 0 ? '' : variant.name }}
                            </li>
                        </ul>
                        <div class="grid-item--set-price">{{ set.price_gross | currency }}</div>
                        <a href="#" @click.prevent="selectSet(set)"
                           class="btn btn-icon-left btn-primary btn-shadow text-uppercase">
                            <span class="material-icon icon-add"></span>
                            {{ $t('select_product') }}
                        </a>
                    </div>
                </div>
            </template>
            <div class="grid-item grid-item--photo" :class="[`item-${i}`]" v-for="(photo, i) in visiblePhotos" :key="i">
                <a href="#" ref="photo" :id="`photo-${photo.id}`" class="skeleton"
                   @click.prevent="selectPhoto(photo.id)" :style="{height: `${photo.clientHeight}px`}">
                    <!--<img v-lazy="photo.medium_photo">-->
                    <img :src="photo.medium_photo">
                    <span v-if="!isMobile" class="grid-item__preview">
                        <template v-if="+photo.not_for_sale || !products || products && !products.length">
                            <span class="material-icon icon-search"></span>
                            {{ $t('preview') }}
                        </template>
                        <template v-else>
                            <span class="material-icon icon-add"></span>
                            {{ $t('order_photo') }}
                        </template>
                    </span>
                </a>
                <template v-if="coreParams.current_shop_package.shop_package.filenames">
                    <ul class="info-list">
                        <li class="info-filename">{{ photo.photo_file_name }}</li>
                        <li class="info-date" v-if="photo.date_taken_original">{{ photo.date_taken_original |
                            moment('DD.MM.YYYY HH:mm') }}
                        </li>
                    </ul>
                </template>
                <template v-if="!+photo.not_for_sale"><!-- && products && products.length > 0-->
                    <div @click="handleFavorite(i)"
                         :id="`favorite-action-${i}`"
                         :class="['btn', 'btn-link', 'grid-item-favorite-icon', {disabled: favoritesMask[i] && favoritesMask[i].disabled}]">
                        <span class="material-icon"
                              :class="`${isFavorite(photo.id) ? 'icon-indeterminate_check_box' : 'icon-library_add'}`"
                        ></span>
                    </div>
                    <b-tooltip v-if="!isMobile" placement="top" :target="`favorite-action-${i}`">
                        {{ $t(isFavorite(photo.id) ? 'helpers.remove_from_selection' : 'helpers.add_to_my_selection') }}
                    </b-tooltip>
                </template>
                <div v-if="!isMobile && +photo.free_download"
                     @click="downloadPhotos(photo.id)"
                     :id="`download-action-${i}`"
                     class="btn btn-link grid-item-download-icon"
                     :class="{'grid-item-download-icon--first': +photo.not_for_sale}">
                    <span class="material-icon icon-cloud_download"></span>
                </div>
                <b-tooltip v-if="!isMobile && +photo.free_download" placement="top" :target="`download-action-${i}`">
                    {{ $t('helpers.download_photo') }}
                </b-tooltip>
                <div v-if="!isMobile && isFavorite(photo.id) || orderedPhotos[photo.id]" class="grid-item-labels">
                    <div v-if="isFavorite(photo.id)" :id="`label-selection-${i}`" class="grid-item-label">{{
                        $t('selected') }}
                    </div>
                    <b-tooltip v-if="isFavorite(photo.id)" placement="top" :target="`label-selection-${i}`">
                        {{ $t('helpers.in_my_selection') }}
                    </b-tooltip>
                    <template v-if="!isMobile">
                        <div v-if="orderedPhotos[photo.id]" :id="`label-cart-${i}`" class="grid-item-label">
                            {{ $t('in_cart') }}
                        </div>
                        <b-tooltip placement="top" :target="`label-cart-${i}`">
                            {{ $t('helpers.photo_in_cart_added') }}
                        </b-tooltip>
                    </template>
                </div>
            </div>
        </isotope>
        <div class="alert alert-info" v-else-if="!loadingPhotosByParams" v-show="!uuid">{{ $t('no_data') }}</div>
    </div>
</template>

<style>
    .grid-item__preview .material-icon {
        margin-right: 7px;
    }
</style>

<style lang="scss" scoped>
    @import "../../scss/variables";

    .disabled {
        pointer-events: none;
    }

    .photos {
        opacity: 1;
        transition: opacity .3s ease;

        &--loading {
            opacity: .05;
            pointer-events: none;
        }
    }

    .grid {
        margin: 0 -10px;

        &-item {
            position: relative;
            width: calc(100% / 3);
            padding: 0 10px;
            margin-bottom: 20px;

            @media (max-width: $size-landscape-phones) {
                width: 50%;
            }

            &:not(.grid-item--set) {

                > * {
                    position: relative;
                    z-index: 1;
                }

                &::before {
                    position: absolute;
                    content: '';
                    width: calc(100% - 20px);
                    height: 100%;
                    top: 0;
                    left: 10px;
                    background-color: var(--bg-secondary-color);
                    pointer-events: none;
                    z-index: 0;
                }

                & > a::before {
                    position: absolute;
                    content: '';
                    width: 100%;
                    height: 100%;
                    top: 0;
                    left: 0;
                    background-color: rgba(#000, 0);
                    pointer-events: none;
                    transition: background-color .3s ease;
                    z-index: 0;
                }

                &:hover {

                    & > a::before {
                        background-color: rgba(#000, .25);
                    }

                    .grid-item__preview {
                        opacity: 1;
                    }
                }

                > a {

                    &,
                    &:hover,
                    &:focus {
                        color: #fff !important;
                        text-decoration: none;
                    }
                }

                .grid-item__preview {
                    position: absolute;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    padding: 8px 22px;
                    top: 50%;
                    left: 50%;
                    font-size: .87rem;
                    text-transform: uppercase;
                    border: 2px solid #fff;
                    border-radius: 23px;
                    transform: translate(-50%, -50%);
                    pointer-events: none;
                    transition: opacity 1s ease;
                    letter-spacing: 1px;
                    white-space: nowrap;
                    opacity: 0;
                    z-index: 1;
                }
            }

            &--disabled {

                > a {
                    pointer-events: none;

                    .grid-item__preview {
                        display: none !important;
                    }
                }

                > div {
                    display: none;
                }

                &:hover {

                    &::before {
                        content: none;
                    }
                }
            }

            &--set {
                padding: 0 10px;

                &-inner {
                    padding: 40px;
                    background-color: var(--bg-secondary-color);
                }

                &-title {
                    color: var(--text-color);
                    font-size: 1.25rem;
                    font-weight: 500;
                }

                &-description {
                    margin-top: 25px;
                    color: var(--text-secondary-color);
                    font-size: 1rem;
                }

                &-items {
                    margin: 25px 0 0;
                    padding: 0;
                    list-style: none;
                }

                &-item {
                    color: var(--text-secondary-color);
                    font-size: 1rem;
                }

                &-price {
                    margin-top: 30px;
                    color: var(--text-color);
                    font-size: 2.1rem;
                    font-weight: 500;
                }

                .btn {
                    margin-top: 15px;
                }
            }

            &--mobile-set {
                width: 100%;
                padding: 0;
            }

            &-id {
                position: absolute !important;
                top: 1px;
                right: 11px;
                padding: 10px;
                color: #eee;
                background-color: #333;
                line-height: 1;
                font-size: .8rem;
                opacity: .85;
            }

            &-ban-icon {
                position: absolute !important;
                bottom: 4px;
                left: 19px;
                color: white;
                pointer-events: none;
            }

            &-labels {
                position: absolute !important;
                top: 12px;
                left: 22px;
                cursor: pointer;
            }

            &-label {
                display: inline-flex;
                align-items: center;
                justify-content: center;
                height: 22px;
                margin-right: 10px;
                padding: 0 10px;
                font-size: .75rem;
                font-weight: 500;
                border-radius: 11px;
                color: #212121;
                background-color: #fafafa;
                box-shadow: 0 2px 2px rgba(#000, .14), 0 3px 1px -2px rgba(#000, .12), 0 1px 5px rgba(#000, .2);

                &:last-child {
                    margin-right: 0;
                }
            }

            &-favorite-icon,
            &-download-icon {
                position: absolute !important;
                top: 5px;
                padding: 5px;
                cursor: pointer;
                text-shadow: 0 1px 3px rgba(#000, .25);

                &,
                &:focus,
                &:hover {
                    color: #fff !important;
                    text-decoration: none;
                }
            }

            &-favorite-icon {
                right: 1rem;
            }

            &-download-icon {
                right: 3.25rem;
                transition: opacity 1s ease;

                &--first {
                    right: 1rem;
                }
            }

            > a {
                display: block;
                overflow: hidden;
                transition: box-shadow .3s ease;
                box-shadow: 0 5px 10px rgba(#000, 0);

                &:hover {
                    box-shadow: 0 8px 10px 1px rgba(#000, .14), 0 3px 14px 2px rgba(#000, .12), 0 5px 5px -3px rgba(#000, .2);
                }

                > img {
                    width: 100%;
                    height: auto;
                }
            }

            .info-list {
                position: absolute !important;
                display: none;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                width: calc(100% - 20px);
                margin: 0;
                padding: 6px 8px;
                list-style: none;
                color: #fff;
                left: 10px;
                bottom: 0;
                font-size: .78rem;
                text-align: center;
                color: rgba(#fff, .78);
                background-color: rgba(#000, .4);
                pointer-events: none;
                overflow: hidden;

                > li {
                    display: none;
                    margin: 0 3px;
                }
            }
        }
    }

    body.-is-mobile {

        .grid-item {

            &::before {
                content: none;
            }

            > a {
                box-shadow: none;
            }
        }
    }
</style>

<script>
  import Isotope from 'vueisotope';
  import imagesLoaded from 'vue-images-loaded';

  import Actionbar from '../Actionbar.vue';

  import photos from 'src/mixins/photosComponent';

  const LIMIT = 9;
  const OFFSET = 200;
  const SCROLL_TIMEOUT = 66;

  export default {
    directives: {
      imagesLoaded,
    },
    mixins: [photos],
    components: {
      Isotope,
      Actionbar,
    },
    data() {
      return {
        visiblePhotos: [],
        favoritesMask: [],
        isotopeOptions: {
          itemSelector: '.grid-item',
          layoutMode: 'masonry',
        },
      };
    },
    watch: {
      albumPhotos(albumPhotos) {
        if (albumPhotos) {
          this.visiblePhotos = [];

          this.$nextTick(() => {
            this.processPhotos(albumPhotos.length > LIMIT ? albumPhotos.slice(0, LIMIT) : albumPhotos);
          });
        }
      },
    },
    methods: {
      processPhotos(albumPhotos) {
        const clientWidth = this.getPhotoClientWidth(true);

        if (clientWidth) {
          albumPhotos.map(photo => {
            const dimensions = JSON.parse(photo.dimensions);
            photo.clientHeight = parseInt(clientWidth * dimensions.height / dimensions.width - 1);
          });
        }

        this.visiblePhotos = albumPhotos;
      },
      async handleFavorite(i) {
        const photoId = this.visiblePhotos[i].id;
        const photoPath = this.visiblePhotos[i].medium_photo;
        const freeDownload = this.visiblePhotos[i].free_download ? +this.visiblePhotos[i].free_download : 0;

        let addingProcess = true;

        const albumIndex = this._.findIndex(this.favorites,
            {albumId: this.album.id});

        if (albumIndex >= 0) {
          const photoIndex = this._.findIndex(this.favorites[albumIndex].items,
              {photoId});
          addingProcess = photoIndex < 0;
        }

        if (addingProcess) {
          await this.$store.dispatch('ADD_FAVORITE', {
            albumId: this.album.id,
            albumTitle: this.album.title !== null
                ? this.album.title
                : this.$t('no_name'),
            albumStatus: this.album.status,
            albumHash: this.album.hash,
            albumHashPassword: this.album.hash_password,
            albumPricelist: this.products && this.products.length > 0 ? 1 : 0,
            tag: this.$store.getters.ALBUM_TAG,
            photoId,
            photoPath,
            freeDownload,
          });
        } else {
          await this.$store.dispatch('DELETE_FAVORITE',
              {albumId: this.album.id, photoId: photoId});
        }
      },
      layout() {
        if (this.$refs.isotope) {
          this.$refs.isotope.layout('masonry');
        }
      },
    },
    created() {
      if (this.albumPhotos) {
        this.processPhotos(this.albumPhotos && this.albumPhotos.length > LIMIT ? this.albumPhotos.slice(0, LIMIT) : this.albumPhotos);
      } else {
        this.visiblePhotos = null;
      }
    },
    mounted() {
      if (!this.uuid) {
        let isScrolling;

        window.onscroll = () => {
          window.clearTimeout(isScrolling);

          isScrolling = setTimeout(() => {
            if (this.albumPhotos && this.albumPhotos.length > LIMIT &&
                (window.innerHeight + window.scrollY) >= (document.body.offsetHeight - OFFSET)) {
              this.processPhotos(this.albumPhotos.slice(0, this.visiblePhotos.length + LIMIT));
            }
          }, SCROLL_TIMEOUT);
        };
      }
    },
  };
</script>
